import React, { Component } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import Linkify from 'react-linkify';
import { SecureLink } from "react-secure-link"

export default function ActionButtons({message}) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  if (message.actionButtons.length == 0) {
    return
  }

  return (
    <>
      <div className="flex-break"></div>
      <div className={"kil-chat-widget-conversation-message-action-buttons"}>
        {message.actionButtons.map((button, i) => (
          <a className={button.colorName + ((button.isClicked) ? ' clicked' : '')} key={(button.id)} href="#"
            onClick={(e) => {
              e.preventDefault();

              if (button.type == 2) {
                window.open(button.action, "_blank");
                return;
              }

              dispatch({ type: 'ACTION_BUTTON_CLICKED', id: button.id })
            }}
          >
              <span>{button.name}</span>
          </a>
        ))}
      </div>
    </>
  )
}